var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoRemoveAttention = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16.453,
    viewBox: "0 0 20 16.453",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_RemoveAttantion",
    transform: "translate(-192.613 -373)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47714",
    "data-name": "Path 47714",
    d: "M209.929,385.4l2.474-2.475a1,1,0,1,0-1.414-1.414l-2.473,2.475-2.475-2.475a1,1,0,1,0-1.414,1.414L207.1,385.4l-2.475,2.474a1,1,0,1,0,1.414,1.414l2.475-2.474,2.473,2.474a1,1,0,1,0,1.414-1.414Z",
    transform: "translate(-.084 -.221)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29010",
    "data-name": "Group 29010",
    transform: "translate(192.613 373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47715",
    "data-name": "Path 47715",
    d: "M203.334,388.59a1.992,1.992,0,0,1,.585-1.42l1.769-1.768-1.768-1.767a2,2,0,1,1,2.828-2.829l1.768,1.767.507-.507a8.318,8.318,0,0,0,.042-.84,8.236,8.236,0,1,0-5.673,7.818A1.968,1.968,0,0,1,203.334,388.59Zm-1.412-3.25a1.064,1.064,0,0,1-.988,1.135c-.032,0-.063,0-.1,0a1.077,1.077,0,0,1-1.085-1.068c0-.023,0-.047,0-.07a1.076,1.076,0,0,1,1.012-1.137c.024,0,.048,0,.071,0a1.056,1.056,0,0,1,1.086,1.025A1.074,1.074,0,0,1,201.922,385.34Zm-.656-3.208c-.164.559-.678.568-.852,0a20.607,20.607,0,0,1-.9-4.758c0-2.13,2.668-2.143,2.668,0A21.123,21.123,0,0,1,201.266,382.132Z",
    transform: "translate(-192.613 -373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47716",
    "data-name": "Path 47716",
    d: "M208.617,383.886l-.1.1-2.475-2.475a1,1,0,1,0-1.414,1.414L207.1,385.4l-2.475,2.474a.99.99,0,0,0-.279.782A8.234,8.234,0,0,0,208.617,383.886Z",
    transform: "translate(-192.613 -373)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoRemoveAttention);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_RemoveAttention.62cacec7edad4e544b32adea2208680d.svg";